import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  FormInputComponent,
  InputComponentConfig,
  SharedModule,
} from '@vendure/admin-ui/core';
import tc from 'tinycolor2';

@Component({
  selector: 'ft-color-form-input',
  imports: [SharedModule],
  template: ` <input
    type="color"
    [readonly]="readonly"
    [formControl]="formControl"
    [value]="formControl.value"
  />`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorFormInputComponent implements OnInit, FormInputComponent {
  static readonly id = 'color-form-input';
  @Input() readonly: boolean;
  formControl: UntypedFormControl;
  config: InputComponentConfig;

  ngOnInit(): void {
    this.formControl.patchValue(tc(this.formControl.value).toHexString());
  }
}
